
<template>
  <section class="content">

    <div v-if="isAreaTable" class="">
      <div class="">
        <div class="">
          <div class=""></div>
          <div id="details house_details_wrp" class="overlay">
            <div class="overlay_inner">
              <div class="row form-modal">
                <h4 class="text-center">Edit Mother Station Details</h4>
                <vue-form :state="formstate" class="formadd_scroll formadd_scroll_margin">
                  <div class="col-sm-12">
                    <div class="col-sm-6">
                      <label>Present Mother Station</label>
                    </div>
                    <div class="col-sm-6">
                      <label class="form-control">{{ motherStationDetails.name }} </label>
                    </div>
                  </div><br><br>
                  <div class="col-sm-12">
                    <div class="col-sm-6">
                      <label>New Mother Station</label>
                    </div>
                    <div class="col-sm-6">
                      <validate auto-label class="form-group required-field">
                        <select v-model="tripException.divertedDestination" required name="divertedDestination"
                          class="form-control">
                          <option disabled>Select Mother Station</option>
                          <option v-for="(item, index) in motherStationDetails.stations" :key="index" :value="item">
                            {{ item.siteName }}
                          </option>
                        </select>
                        <field-messages name="divertedDestination" show="$touched || $submitted"
                          class="form-control-feedback">
                          <div slot="required">This is a required field</div>
                        </field-messages>
                      </validate>
                    </div>
                  </div><br><br>
                </vue-form>
                <div class="form-actions">
                  <button class="mr-5 btn btn-default" type="button" @click="onCancel">Cancel</button>
                  <button class="mr-2 btn gradientbt" type="submit" @click="updateMotherStation"
                    :disabled="!(formstate.$dirty && formstate.$valid)">Update</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document" style="width: 80%">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="tableBox">
      <div class="box-body box-body-hcv">
        <div class="headerText">HCV Optimization System</div>
        <div :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER]">
          <router-link :to="{ name: 'TripGroupCreate' }">
            <button class="btn addnew">Add Group Trip</button>
          </router-link>
        </div>
        <v-server-table ref="hcvdetailsTable" url :columns="columns" :options="options" @loaded="onLoaded"
          class="table-responsive-hcv ">
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
          <template slot="map" slot-scope="props">
            <div>
              <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#exampleModal"
                @click="getstartLocation(props.row)">
                Show Map
              </button>
            </div>
          </template>

          <template slot="motherStation" slot-scope="props">
            <div v-if="props.row.motherStation !== ''">
              <span>{{ props.row.motherStation }}</span><a class="fa fa-edit" role="button"
                v-on:click.stop="action(props.row)"></a>
            </div>

            <span v-if="props.row.motherStation === ''">{{ '--' }}</span>
          </template>
          <!-- <template slot="trip" slot-scope="props">
            <div v-if="!props.row.triggerHCV">
              <router-link :to="{ name: 'TripCreate' }" class="trigger-create">
                Create
              </router-link>
            </div>
            <div v-else>--</div>
          </template> -->

          <!-- <template slot="Trigger_HCV" slot-scope="props">
            <div v-if="props.row.Trigger_HCV !== null">
              <div v-if="
                props.row.Trigger_HCV <= 0 && props.row.Trigger_HCV !== null
              " class="trigger-required">
                Required
              </div>
              <div v-else-if="props.row.Trigger_HCV > 0">
                {{ props.row.Trigger_HCV }}
              </div>
              <div v-if="props.row.Trigger_HCV === null">--</div>
            </div>
            <div v-else>--</div>
            </template> -->
        </v-server-table>
      </div>
    </div>
  </section>
</template>
<script>
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import moment from 'moment';
import axios from 'axios';
import Vue from 'vue';
import { parse } from 'querystring';
import { siteService } from '../../../services/'
import Config from '../../../config';
export default {
  name: 'HcvStatus',
  data() {
    return {
      formstate: {},
      regions: [],
      motherStationOptions: [],
      pageNumber: null,
      motherStationDetails: {},
      startLocation: {
        lat: '',
        lng: '',
      },
      mapMarkers: {},
      coordinates: {},
      siteData: null,
      infoPosition: null,
      infoContent: null,
      infoOpened: false,
      infoCurrentKey: null,
      stationeryGas: '',
      infoOptions: {},
      tripException: {
        prevDestination: '',
        docId: ''
      },
      isAreaTable: false,
      pixelOffset: {
        width: 0,
        height: -35,
      },
      timer: '',
      hcvdetails: {},
      USER_ROLES: USER_ROLES,
      loading: null,
      hcvdetailsTable: null,
      columns: [
        'regionName',
        'siteName',
        'scadaValue',
        // 'status',
        'hcvDetail',
        'HCVGasAvailable',
        'cascadeGas',
        'total',
        'livedetail',
        'onGoingHCV',
        'averageSalesValue',
        'motherStation',
        'timeTaken',
        'Trigger_HCV',
        'livedetailHCV',
        'salesData'
      ],
      options: {
        highlightMatches: true,
        sortable: [
          'scadaValue',
          'HCVGasAvailable'

        ],
        headings: {
          regionName: 'GA',
          siteName: 'Station',
          scadaValue: 'Suction Pressure (Bar)',
          status: 'HCV Availability',
          hcvDetail: 'HCV Connected',
          HCVGasAvailable: 'Gas Stock - HCV (Kg)',
          cascadeGas: 'Gas Stock - Station (Kg)',
          total: 'Total Stock (Kg)',
          onGoingHCV: 'HCV in Transit',
          averageSalesValue: 'Expected Sale Time (Hr)',
          motherStation: 'Mother Station',
          livedetail: 'Available HCV',
          livedetailHCV: 'HCV at MS',
          Trigger_HCV: 'Trigger HCV when C<D',
          timeTaken: 'Travel Time (Hr)',
          recordedTime: 'Refresh Time',
          recordedTimeSales: 'Refresh Time Sales',
          salesData: 'Sales Value'

        },
        templates: {
          status(row, query) {
            if (query.livedetails) {
              if (query.livedetails.description == 'Decanting') {
                return 'Yes';
              } else {
                return 'No';
              }
            } else {
              return 'No';
            }
          },
          hcvDetail(row, query) {
            if (query.livedetails) {
              if (query.livedetails.description == 'Decanting') {
                return query.hcvDetail;
              } else {
                return '--';
              }
            } else {
              return '--';
            }
          },
          // motherStation(row, query) { if (query.motherStation !== '') { return query.motherStation } else { return "--" } },

          // motherStation(row, query) {},

          scadaValue(row, query) {
            if (query.scadaValue) {
              let val = (query.scadaValue);
              return val;
            } else {
              return '--';
            }
          },

          HCVGasAvailable(row, query) {
            if (query.livedetails) {
              if (query.livedetails.description == 'Decanting') {
                if (
                  query.HCVGasAvailability &&
                  !isNaN(query.HCVGasAvailability)
                ) {
                  let HCVGas = (query.HCVGasAvailability);
                  return HCVGas;
                } else {
                  return '--';
                }
              } else {
                return '--';
              }
            } else {
              return '--';
            }
          },

          cascadeGas(row, query) {
            this.stationeryGas = null;
            if (query.scadaValue && query.livedetails && query.livedetails.description !== 'Decanting') {
              this.stationeryGas = (query.cascadeGasCapacity / 1.25 * (query.scadaValue - 40) / 1000) * (1.225 * 0.5813)
              return (this.stationeryGas).toFixed(0);
            } else if (query.hcvDetail && query.scadaValue && query.livedetails.description == 'Decanting') {
              this.stationeryGas = (query.cascadeGasCapacity / 1.25 * (140) / 1000) * (1.225 * 0.5813)
              return (this.stationeryGas).toFixed(0);
            } else {
              return '--'
            }

          },

          total(row, query) {
            if (query.HCVGasAvailability && this.stationeryGas) {
              let totalGasInventory = query.HCVGasAvailability + this.stationeryGas
              return (totalGasInventory).toFixed(0);
            } else if (this.stationeryGas !== null) {
              return (this.stationeryGas).toFixed(0);
            } else {
              return '--';
            }
          },

          livedetail(row, query) {
            if (query.hCVAtDBS && query.hCVAtDBS.length > 0) {
              let hcvAtDaughterStation = []
              query.hCVAtDBS.forEach(element => {
                hcvAtDaughterStation.push(element.vehicleNumber)
              });
              return (hcvAtDaughterStation.join());
            } else {
              return '--';
            }
          },

          livedetailHCV(row, query) {
            var msVehicles = []
            var msScheduled = []

            if (query.avialableMsVehicle && query.avialableMsVehicle.length > 0) {
              query.avialableMsVehicle.forEach(element => {
                msVehicles.push(element.vehicleNumber)
              });
            }
            if (query.scheduledAtMS && query.scheduledAtMS.length > 0) {
              query.scheduledAtMS.forEach(element => {
                msScheduled.push(element.vehicleNo)
              });
            }
            let totalVehicles = msVehicles.concat(msScheduled)
            if (totalVehicles.length > 0) {
              let test = totalVehicles.filter((item,
                index) => totalVehicles.indexOf(item) === index);
              return test.join()
            } else {
              return '--'
            }
          },

          timeTaken(row, query) {
            if (query.timeTaken && !isNaN(query.timeTaken)) {
              return moment.utc(query.timeTaken * 60 * 1000).format('HH[h] mm[m]')
            } else {
              return '--';
            }
          },
          onGoingHCV(row, query) {
            if (query.ongoingHCV && query.ongoingHCV.length > 0) {
              let vehicles = []
              query.ongoingHCV.forEach(element => {
                vehicles.push(element.vehicleNo)
              });
              return (vehicles.join());
            } else {
              return '--';
            }
          },

          averageSalesValue(row, query) {
            if (this.stationeryGas && query.salesData) {
              let totalGasInventory = (query.HCVGasAvailability + this.stationeryGas)
              const salesvalue = (totalGasInventory / query.salesData).toFixed(0)
              return moment.utc(salesvalue * 60 * 60 * 1000).format('HH[h] mm[m]')
            } else {
              return '--';
            }

          },
          Trigger_HCV(row, query) {
            if (query.HCVGasAvailability && this.stationeryGas && query.salesData) {
              let totalGasInventory = (query.HCVGasAvailability + this.stationeryGas)
              const salesvalue = (totalGasInventory / query.salesData).toFixed(0)
              let timetaken = (query.timeTaken / 60)
              const difference = salesvalue - timetaken
              if (difference > 0) {
                return 'Not Required '
              } else {
                return `Required ${difference.toFixed(0)}`
              }
            } else {
              return '--';
            }

          },

          recordedTime(row, query) {
            if (query.recordedTime) {
              return moment(query.recordedTime).format('DD-MM-YYYY hh:mm A')
            } else {
              return '--'
            }
          },

          recordedTimeSales(row, query) {
            if (query.recordedTimeSales) {
              return moment(query.recordedTimeSales).format('DD-MM-YYYY hh:mm A')
            } else {
              return '--'
            }
          },
        },
        requestFunction: request => {
          this.loading = true
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (request.query) {
            params.$term = request.query;
          }
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          }
          if (this.$store.state.auth.user.roleName === 'Journey Manager') {
            let regionDetails = this.$store.state.auth.userRegion.regionDetails
            let regions = regionDetails.map((el) => {
              return el.name
            })
            params.regionName = regions
          }
          return this.$hcvdetailsDataRepository.list(params).catch(error => {
            this.loading = false
            console.error('liveStatus.requestFunction-error:', error);
            this.$snotify.error('Get Vehicle Status', 'Error!');
          })
        },
        responseAdapter: (response) => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total,
          };
        },
      },
    };
  },
  created() {
    this.timer = setInterval(this.onLoaded1, 60000)
    // this.timer1 = setInterval(this.getVehicleStatus,60000)
  },
  mounted: function () {
    if (this.$store.state.auth.user.roleRank === 1) {
      this.columns.push("recordedTime");
      this.columns.push("recordedTimeSales")

    }
    // eventBus.$on("DATA_PUBLISHED", (payload) => {});
    console.log('called Me', this.$store.state.auth.user.roleName === 'Admin');


    // this.loadInitTableData()
  },

  beforeDestroy() {
    clearInterval(this.timer)
  },
  watch: {
    pageNumber(newPage, oldPage) {
      this.fetchMotherStationOptions();
    },
  },



  methods: {

    action(row) {
      this.isAreaTable = true
      let motherStationDetails = {
        name: row.motherStation,
        stations: row.motherStations,
        motherStationId: row.motherstationId
      }
      this.motherStationDetails = motherStationDetails
      this.getSiteDetail(row.siteId)

    },

    async getSiteDetail(siteId) {
      let url = `${Config.serverURI}/site/${siteId}`
      try {
        this.siteData = await axios.get(url)
      } catch (error) {
        console.log("error")
      }

    },

    onCancel() {
      this.isAreaTable = false;
    },

    onLoaded1() {
      this.$refs.hcvdetailsTable.refresh();
    },

    onLoaded() {
      this.hcvdetailsTable = this.$refs.hcvdetailsTable;
    },

    updateMotherStation() {
      let Updatedsite = this.siteData.data

      let data = {
        address: Updatedsite.address,
        capacity: Updatedsite.capacity,
        customerName: Updatedsite.customerName,
        dateAdded: Updatedsite.dateAdded,
        defaultMS: this.tripException.divertedDestination._id,
        deviceId: Updatedsite.deviceId,
        dispenserCount: Updatedsite.dispenserCount,
        email: Updatedsite.email,
        latitude: Updatedsite.latitude,
        location_tag: Updatedsite.location_tag,
        longitude: Updatedsite.longitude,
        ownerAddress: Updatedsite.ownerAddress,
        ownerEmail: Updatedsite.ownerEmail,
        ownerMobile: Updatedsite.ownerMobile,
        ownerName: Updatedsite.ownerName,
        region: Updatedsite.region,
        salesManager: Updatedsite.salesManager,
        siteCode: Updatedsite.siteCode,
        siteInfoImage: Updatedsite.siteInfoImage,
        siteName: Updatedsite.siteName,
        siteType: Updatedsite.siteType,
        status: Updatedsite.status,
        supervisor: Updatedsite.supervisor,
        _id: Updatedsite._id

      }
      return siteService.updateSite(data).then((response) => {
        this.loading = false
        this.$snotify.success('Mother station Updated successfully', 'Success!')
        this.isAreaTable = false

      }).catch(error => {
        this.loading = false
        this.$snotify.error('Location Add failed! Try Again', 'Error!')
        this.isAreaTable = false
      })
    },



    getVehicleStatus() {
      return this.$hcvdetailsDataRepository
        .list({
          isDeleted: false,
        })
        .then((response) => {
          console.log("called")
          this.hcvdetails = response.data;
          this.coordinates = response.data.docs;
          // console.log('respppp---->>>>',this.coordinates)
        })
        .catch((error) => {
          this.$snotify.error('Trip detail failed', 'Error!');
        });
    },

  },
  computed: {
    addButtonClass() {
      if (this.hcvdetailsTable) {
        return this.hcvdetailsTable.count > this.hcvdetailsTable.limit ||
          this.hcvdetailsTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
  },
};
</script>
<style>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

}

.box-body-hcv .table-bordered>tbody>tr>td {
  border: 2px solid black;
  max-width: 110px;
  word-wrap: break-word;
  min-width: 110px;
  text-align: center;
}

.box-body-hcv .table-bordered>tfoot>tr>td {
  border: 2px solid black;

}

.box-body-hcv .table>thead:first-child>tr:first-child>th {
  border-top: 2px solid black;
  text-align: center;
  vertical-align: middle;

}

.box-body-hcv .table-bordered>thead>tr>th {
  border: 2px solid black;
}

.table-bordered>thead>tr>th:nth-child(14) {
  min-width: 250px
}



.toggle {
  --width: 64px;
  --height: calc(var(--width) / 3);

  position: relative;
  display: inline-block;
  width: var(--width);
  height: var(--height);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  border-radius: var(--height);
  cursor: pointer;
  margin-bottom: 0px;
  position: relative;
  top: 2px;
}

.table-new>table-bordered>thead>tr>th,
.table-new>table-bordered>tbody>tr>th,
.table-new>table-bordered>tfoot>tr>th,
.table-new>table-bordered>thead>tr>td,
.table-new>table-bordered>tbody>tr>td,
.table-new>table-bordered>tfoot>tr>td {
  border: 2px solid black
}


.toggle input {
  display: none;
}

.toggle .slider {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: var(--height);
  background-color: #ccc;
  transition: all 0.4s ease-in-out;
}

.toggle .slider::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: calc(var(--height));
  height: calc(var(--height));
  border-radius: calc(var(--height) / 2);
  background-color: #fff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  transition: all 0.4s ease-in-out;
}

.toggle input:checked+.slider {
  background-color: #0f6940;
}

.toggle input:checked+.slider::before {
  transform: translateX(calc(var(--width) - var(--height)));
}

.toggle .labels {
  position: absolute;
  top: 4px;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 10px;
  font-family: sans-serif;
  transition: all 0.4s ease-in-out;
}

.toggle .labels::after {
  content: attr(data-off);
  position: absolute;
  right: 5px;
  color: #4d4d4d;
  opacity: 1;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
  transition: all 0.4s ease-in-out;
}

.toggle .labels::before {
  content: attr(data-on);
  position: absolute;
  left: 5px;
  color: #ffffff;
  opacity: 0;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
  transition: all 0.4s ease-in-out;
}

.toggle input:checked~.labels::after {
  opacity: 0;
}

.toggle input:checked~.labels::before {
  opacity: 1;
}

.active_wrp {
  display: flex;
  align-items: center;
}

.active_wrp a {
  flex: 0 0 30%;
  color: #0f6940;
  margin-right: 10px;
}

.tablePopUp {
  border-collapse: collapse;
  border: 1px solid black;
  table-layout: auto;
  width: 440px;
}

.table_scroll {
  height: 200px;
  overflow: auto;
}

.table_scroll::-webkit-scrollbar {
  width: 5px;
}

.table_scroll::-webkit-scrollbar-thumb {
  background: #888;
}

.password-popup-width h1 {
  font-size: 22px;
  margin-bottom: 10px;
  font-weight: 600;
}

/* th,
td {
  border: 1px solid black;
  padding: 5px;
  text-align: left;
} */

.password-popup {
  height: 100%;
  width: 100%;
  z-index: 10;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  text-align: center;
  box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
  z-index: 9999;
  background-color: rgb(0 0 0 / 50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.tablePopUp {
  border-collapse: collapse;
  border: 1px solid black;
  table-layout: auto;
  width: 440px;
}

.cancelButton {
  background-color: #f44336;
  border-radius: 8px;
  left: 47%;
  position: fixed;
  bottom: 100px;
}

.password-popup-width {
  padding-top: 0px;
  background: #fff;
  width: 500px;
  height: 300px;
  padding: 20px;
  border-radius: 10px;
  position: relative;
}

.password-popup-width .toggle {
  box-shadow: none;
  border: none;
  width: auto;
  position: absolute;
  right: 10px;
  top: 10px;
}

.table_scroll {
  height: 200px;
  overflow: auto;
}





.password-popup-width .toggle svg {
  width: 20px;
  height: 20px;
}

.overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.sidepop {
  position: fixed;
  width: 600px;
  z-index: 9999;
  margin: 0 auto;
  padding: 20px 30px;
  background-color: #fff;
  right: 0;
  top: 0;
  height: 100%;
}

.form-modal {
  background: #fff;
  width: 60%;
  padding: 0;
}

.text-center {
  text-align: center;
}

.overlay_inner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.overlay_inner .form-modal h4 {
  background: #f1f1f1;
  padding: 20px;
  margin: 0;
  border-bottom: 1px solid #ddd;
  text-align: left;
}

.overlay_inner .form-actions {
  text-align: right;
  padding: 20px 15px;
  border-top: 1px solid #ddd;
  display: inline-block;
  width: 100%;
}

.formadd_scroll {
  overflow: auto;
  overflow-x: hidden;
  padding: 15px 0px;
}

.formadd_scroll_margin {
  margin-left: -15px;
  margin-right: -15px;
}

.formadd_scroll::-webkit-scrollbar {
  width: 5px;
}

.formadd_scroll::-webkit-scrollbar-thumb {
  background: #888;
}

.datedrop_boxs_wrapper {
  position: relative;
  z-index: 2;
}

.datedrop_boxs_inner {
  position: absolute;
  right: 185px;
  top: 5px;
}

.datedrop_boxs_inner button {
  background: #0F6940;
  color: #fff;
  border: 0;
  padding: 5px 20px;
  border-radius: 5px;
}

.datedrop_rel_inner .d-flex {
  background: #fff;
  padding: 10px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.multiselected {
  min-width: 145px;
  max-width: 146px;
}

.flex {
  display: flex;
}

.table-responsive-hcv thead {
  background: #1086ac;
  position: sticky;
  z-index: 1;
  top: -1px;
  left: 0;
}

.headerText {
  background: #ff5312;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  min-height: 40px;
  margin-bottom: 10px;
  /* font-weight: 600; */
}

.addnew {
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
  color: white
}

@media (max-width: 1199px) {
  .formadd_scroll {
    height: 290px;
  }
}
</style>


// WEBPACK FOOTER //
// HcvStatus.vue?2c1a0898